import React from "react"
import { useParams } from "react-router-dom"
import { AuthorizationComponent } from "../../components/authorization"
import { BreadcrumbComponent } from "../../components/common/breadcrumb"
import { DefaultPageComp } from "../../components/defaultPage"

export const AuthorizationPage = () => {
  const { id } = useParams()
  return <>
    <DefaultPageComp>
      <BreadcrumbComponent />
      <AuthorizationComponent id={Number(id)} />
    </DefaultPageComp>
  </>
}